import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        myCars: "My Cars 🚗",
        noCars: "No cars yet",
        signOut: "Sign out",
        addCar: "+ Add Car",
        addNewCar: "Add New Car 🚗",
        back: "← Back",
        serviceHistory: "Service History",
        noRecords: "No service records yet",
        addRecord: "+ Add Record",
        date: "Date",
        mileage: "Mileage",
        cost: "Cost",
        service: "Service",
        station: "Station",
        notes: "Notes",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        addServiceRecord: "Add Service Record 🛠️",
        description: "Description",
        serviceStation: "Service Station",
        editCar: "Edit Car 🚗",
        saveChanges: "Save Changes",
        carName: "Car Name (nickname)",
        brand: "Brand",
        model: "Model",
        licensePlate: "License Plate",
        vin: "VIN",
        loading: "Loading...",
        carNotFound: "Car not found.",
        fillFields: "Please fill in all required fields",
        welcomeBack: "Welcome back",
        createAccount: "Create Account",
        yourName: "Your name",
        password: "Password",
        signIn: "Sign In",
        register: "Register",
        or: "or",
        continueWithGoogle: "Continue with Google",
        alreadyHaveAccount: "Already have an account?",
        dontHaveAccount: "Don't have an account?",
        serverError: "Server error, try again",
        tagline: "Your car service notes. Always at hand.",
      },
    },
    ru: {
      translation: {
        myCars: "Мои авто 🚗",
        noCars: "Авто пока нет",
        signOut: "Выйти",
        addCar: "+ Добавить авто",
        addNewCar: "Добавить авто 🚗",
        back: "← Назад",
        serviceHistory: "История обслуживания",
        noRecords: "Записей пока нет",
        addRecord: "+ Добавить запись",
        date: "Дата",
        mileage: "Пробег",
        cost: "Стоимость",
        service: "Вид работ",
        station: "Станция",
        notes: "Заметки",
        edit: "Изменить",
        delete: "Удалить",
        save: "Сохранить",
        cancel: "Отмена",
        addServiceRecord: "Добавить запись 🛠️",
        description: "Описание",
        serviceStation: "Сервисная станция",
        editCar: "Редактировать авто 🚗",
        saveChanges: "Сохранить изменения",
        carName: "Название (псевдоним)",
        brand: "Марка",
        model: "Модель",
        licensePlate: "Номерной знак",
        vin: "VIN",
        loading: "Загрузка...",
        carNotFound: "Авто не найдено.",
        fillFields: "Пожалуйста, заполните все обязательные поля",
        welcomeBack: "С возвращением",
        createAccount: "Создать аккаунт",
        yourName: "Ваше имя",
        password: "Пароль",
        signIn: "Войти",
        register: "Регистрация",
        or: "или",
        continueWithGoogle: "Войти через Google",
        alreadyHaveAccount: "Уже есть аккаунт?",
        dontHaveAccount: "Нет аккаунта?",
        serverError: "Ошибка сервера, попробуйте снова",
        tagline: "Заметки об обслуживании вашего авто. Всегда под рукой.",
      },
    },
    cs: {
      translation: {
        myCars: "Moje auta 🚗",
        noCars: "Zatím žádná auta",
        signOut: "Odhlásit se",
        addCar: "+ Přidat auto",
        addNewCar: "Přidat nové auto 🚗",
        back: "← Zpět",
        serviceHistory: "Historie servisu",
        noRecords: "Zatím žádné záznamy",
        addRecord: "+ Přidat záznam",
        date: "Datum",
        mileage: "Nájezd",
        cost: "Cena",
        service: "Druh práce",
        station: "Stanice",
        notes: "Poznámky",
        edit: "Upravit",
        delete: "Smazat",
        save: "Uložit",
        cancel: "Zrušit",
        addServiceRecord: "Přidat záznam 🛠️",
        description: "Popis",
        serviceStation: "Servisní stanice",
        editCar: "Upravit auto 🚗",
        saveChanges: "Uložit změny",
        carName: "Název (přezdívka)",
        brand: "Značka",
        model: "Model",
        licensePlate: "SPZ",
        vin: "VIN",
        loading: "Načítání...",
        carNotFound: "Auto nenalezeno.",
        fillFields: "Prosím vyplňte všechna povinná pole",
        welcomeBack: "Vítejte zpět",
        createAccount: "Vytvořit účet",
        yourName: "Vaše jméno",
        password: "Heslo",
        signIn: "Přihlásit se",
        register: "Registrovat",
        or: "nebo",
        continueWithGoogle: "Pokračovat přes Google",
        alreadyHaveAccount: "Již máte účet?",
        dontHaveAccount: "Nemáte účet?",
        serverError: "Chyba servera, zkuste znovu",
        tagline: "Poznámky o servisu vašeho auta. Vždy po ruce.",
      },
    },
    uk: {
      translation: {
        myCars: "Мої авто 🚗",
        noCars: "Авто поки немає",
        signOut: "Вийти",
        addCar: "+ Додати авто",
        addNewCar: "Додати авто 🚗",
        back: "← Назад",
        serviceHistory: "Історія обслуговування",
        noRecords: "Записів поки немає",
        addRecord: "+ Додати запис",
        date: "Дата",
        mileage: "Пробіг",
        cost: "Вартість",
        service: "Вид робіт",
        station: "Станція",
        notes: "Нотатки",
        edit: "Редагувати",
        delete: "Видалити",
        save: "Зберегти",
        cancel: "Скасувати",
        addServiceRecord: "Додати запис 🛠️",
        description: "Опис",
        serviceStation: "Сервісна станція",
        editCar: "Редагувати авто 🚗",
        saveChanges: "Зберегти зміни",
        carName: "Назва (псевдонім)",
        brand: "Марка",
        model: "Модель",
        licensePlate: "Номерний знак",
        vin: "VIN",
        loading: "Завантаження...",
        carNotFound: "Авто не знайдено.",
        fillFields: "Будь ласка, заповніть усі обов'язкові поля",
        welcomeBack: "З поверненням",
        createAccount: "Створити акаунт",
        yourName: "Ваше ім'я",
        password: "Пароль",
        signIn: "Увійти",
        register: "Реєстрація",
        or: "або",
        continueWithGoogle: "Увійти через Google",
        alreadyHaveAccount: "Вже є акаунт?",
        dontHaveAccount: "Немає акаунту?",
        serverError: "Помилка сервера, спробуйте знову",
        tagline: "Нотатки про обслуговування вашого авто. Завжди під рукою.",
      },
    },
    de: {
      translation: {
        myCars: "Meine Autos 🚗",
        noCars: "Noch keine Autos",
        signOut: "Abmelden",
        addCar: "+ Auto hinzufügen",
        addNewCar: "Neues Auto hinzufügen 🚗",
        back: "← Zurück",
        serviceHistory: "Serviceverlauf",
        noRecords: "Noch keine Einträge",
        addRecord: "+ Eintrag hinzufügen",
        date: "Datum",
        mileage: "Kilometerstand",
        cost: "Kosten",
        service: "Serviceart",
        station: "Werkstatt",
        notes: "Notizen",
        edit: "Bearbeiten",
        delete: "Löschen",
        save: "Speichern",
        cancel: "Abbrechen",
        addServiceRecord: "Serviceeintrag hinzufügen 🛠️",
        description: "Beschreibung",
        serviceStation: "Werkstatt",
        editCar: "Auto bearbeiten 🚗",
        saveChanges: "Änderungen speichern",
        carName: "Autoname (Spitzname)",
        brand: "Marke",
        model: "Modell",
        licensePlate: "Kennzeichen",
        vin: "FIN",
        loading: "Laden...",
        carNotFound: "Auto nicht gefunden.",
        fillFields: "Bitte alle Pflichtfelder ausfüllen",
        welcomeBack: "Willkommen zurück",
        createAccount: "Konto erstellen",
        yourName: "Ihr Name",
        password: "Passwort",
        signIn: "Anmelden",
        register: "Registrieren",
        or: "oder",
        continueWithGoogle: "Mit Google fortfahren",
        alreadyHaveAccount: "Bereits ein Konto?",
        dontHaveAccount: "Noch kein Konto?",
        serverError: "Serverfehler, bitte erneut versuchen",
        tagline: "Servicenotizen für Ihr Auto. Immer griffbereit.",
      },
    },
    pl: {
      translation: {
        myCars: "Moje auta 🚗",
        noCars: "Brak aut",
        signOut: "Wyloguj",
        addCar: "+ Dodaj auto",
        addNewCar: "Dodaj nowe auto 🚗",
        back: "← Wstecz",
        serviceHistory: "Historia serwisu",
        noRecords: "Brak wpisów serwisowych",
        addRecord: "+ Dodaj wpis",
        date: "Data",
        mileage: "Przebieg",
        cost: "Koszt",
        service: "Rodzaj usługi",
        station: "Stacja",
        notes: "Notatki",
        edit: "Edytuj",
        delete: "Usuń",
        save: "Zapisz",
        cancel: "Anuluj",
        addServiceRecord: "Dodaj wpis serwisowy 🛠️",
        description: "Opis",
        serviceStation: "Stacja serwisowa",
        editCar: "Edytuj auto 🚗",
        saveChanges: "Zapisz zmiany",
        carName: "Nazwa auta (pseudonim)",
        brand: "Marka",
        model: "Model",
        licensePlate: "Tablica rejestracyjna",
        vin: "VIN",
        loading: "Ładowanie...",
        carNotFound: "Nie znaleziono auta.",
        fillFields: "Proszę wypełnić wszystkie wymagane pola",
        welcomeBack: "Witaj ponownie",
        createAccount: "Utwórz konto",
        yourName: "Twoje imię",
        password: "Hasło",
        signIn: "Zaloguj się",
        register: "Zarejestruj się",
        or: "lub",
        continueWithGoogle: "Kontynuuj przez Google",
        alreadyHaveAccount: "Masz już konto?",
        dontHaveAccount: "Nie masz konta?",
        serverError: "Błąd serwera, spróbuj ponownie",
        tagline: "Notatki o serwisie twojego auta. Zawsze pod ręką.",
      },
    },
  },
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;